// // import { Injectable } from '@angular/core';
// // import { CanActivate, Router } from '@angular/router';

// // @Injectable({
// //   providedIn: 'root',
// // })
// // export class NoAuthGuard implements CanActivate {
// //   constructor(private router: Router) {}

// //   canActivate(): boolean {
// //     const accessToken = localStorage.getItem('accessToken');
// //     const tokenExpiry = localStorage.getItem('tokenExpiry');

// //     // If the user is already logged in, redirect to the default route
// //     if (accessToken && tokenExpiry && Date.now() < +tokenExpiry) {
// //       this.router.navigate(['/workspace/projects']);
// //       return false; // Prevent access to the /login route
// //     }

// //     // If not logged in, allow access to the /login route
// //     return true;
// //   }
// // }
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const accessToken = localStorage.getItem('accessToken');
    const tokenExpiry = localStorage.getItem('tokenExpiry');
    const isLoggedIn = accessToken && tokenExpiry && Date.now() < +tokenExpiry;

    // Public routes that logged-in users should NOT access
    const publicRoutes = [
      '/login',
      '/vendors/login',
      '/customers/login',
      '/customer/forgot-password',
      '/reset-password',
      'customers/profile'
    ];

    if (isLoggedIn) {
      // If user is logged in and trying to access a public route, redirect based on visibility
      if (publicRoutes.includes(state.url)) {
        const userInfo = this.getUserInfo();
        const visibility = this.getVisibility(userInfo);

        console.log('NoAuthGuard - visibility:', visibility);

        if (visibility === 'vendor') {
          this.router.navigate(['/workspace/vendor/dashboard']);
        } else if (visibility === 'customer') {
          this.router.navigate(['/workspace/customer']);
        } else {
          this.router.navigate(['/workspace/internal-team']);
        }
        return false;
      }
    }

    return true;
  }

  private getVisibility(userInfo: any): string {
    if (!userInfo) return '';
    const raw = (userInfo['custom:visibility'] || userInfo.visibility || '').toString().toLowerCase();
    return raw;
  }

  private getUserInfo(): any {
    try {
      const userInfoString = localStorage.getItem('userInfo');
      return userInfoString ? JSON.parse(userInfoString) : null;
    } catch (e) {
      console.error('Error parsing userInfo', e);
      return null;
    }
  }
}